import { connect } from "react-redux";
import { refreshBorrow } from "../actions";

const mapDispatchToProps = (dispatch) => ({
  setRefreshBorrow: (data) => {
    dispatch(refreshBorrow(data));
  },
});

const mapStateToProps = (state) => ({
  refreshBorrow: state.refreshBorrow,
});

export default connect(mapStateToProps, mapDispatchToProps);